import { render, staticRenderFns } from "./IInstitucional.vue?vue&type=template&id=f9ab27e0&"
import script from "./IInstitucional.vue?vue&type=script&lang=js&"
export * from "./IInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports